function closeCitySelectPopop() {
    $('#city-select-popop-block').css('display', 'none');
}

$(document).on("click", '.city-select-box', function () {
    $('#city-select-popop-block').css('display', 'flex');
});

$(document).on("click", '.close-city-select-popop', function () {
    closeCitySelectPopop();
});

$(document).on("click", '.attribute_list .atrbaz, .color_pick', function () {

    setTimeout(function () {
        getProductDeliveryTime();
    }, 150);

});

$(document).on("click", '.submit-select-city', function (event) {


    event.preventDefault();

    var selectedId = $('.active-city').data('id');

    if (!selectedId) {
        return true;
    }

    $('.submit-select-city').spinner();

    $.ajax({
        type: 'POST',
        async: true,
        cache: false,
        dataType: 'json',
        url: this.dataset.url,
        headers: {
            'cache-control': 'no-cache'
        },
        data: {setCity: selectedId, ajax: true},
        success: function (data) {
            $('.select-city-box-text .city-box').html(data.name);

            if ($(".city-select-box").length > 0) {
                $('.city-select-box strong').html(data.name);
            }

            closeCitySelectPopop();
            $('.submit-select-city').spinner('end');

            if ($("#delivery-time-box").length > 0) {
                if ($("#product_page_product_id").length > 0) {
                    getProductDeliveryTime();
                }
                if ($("#module-cartview-cart").length > 0) {
                    getCartDeliveryTime();
                }

            }

            if ($(".delivery-type-time-text-carrier-72").length > 0) {
                getCartBoxDeliveryTime();
            }
        }
    });

});

$(document).on("click", '.city-item', function () {
    var id = this.dataset.id;

    $('.city-select-popop-content-city-list span').removeClass('active-city');
    $('.city-id-' + id).addClass('active-city');

});

$(document).ready(function () {
    if ($("#delivery-time-box").length > 0) {

        if ($("#product_page_product_id").length > 0) {
            setTimeout(function () {
                getProductDeliveryTime();
            }, 150);
        }

        try {
            $('.tooltip-block').tooltip({delay: 40});
        } catch (err) {

        }

    }
});

function getCartDeliveryTime() {
    $('.delivery-time-text div').spinner();

    $.ajax({
        type: 'POST',
        async: true,
        cache: false,
        url: $('.submit-select-city').data('url'),
        headers: {
            'cache-control': 'no-cache'
        },
        data: {
            getCartDeliveryTime: true,
            ajax: true,
        },
        success: function (data) {
            $('.delivery-time-text div').spinner('end');
            $('#delivery-time-box .delivery-time-text div').html(data);
        }
    });
}

function getCartBoxDeliveryTime() {
    $('.delivery-type-time-text-carrier-72').spinner();
    $.ajax({
        type: 'POST',
        async: true,
        cache: false,
        url: $('.submit-select-city').data('url'),
        headers: {
            'cache-control': 'no-cache'
        },
        data: {
            getCartBoxDeliveryTime: true,
            ajax: true,
        },
        success: function (data) {
            $('.delivery-type-time-text-carrier-72').spinner('end');
            $('.delivery-type-time-text-carrier-72').html(data);
        }
    });
}

function getProductDeliveryTime() {

    if ($("#product_page_product_id").length < 1) {
        return true;
    }


    if (Math.floor($("#idCombination").val()) == $("#idCombination").val() && $.isNumeric($("#idCombination").val())) {
        var idCombination = $("#idCombination").val();
    } else {
        var idCombination = 0;
    }

    $('.delivery-time-text div').spinner();

    $.ajax({
        type: 'POST',
        async: true,
        cache: false,
        url: $('.submit-select-city').data('url'),
        headers: {
            'cache-control': 'no-cache'
        },
        data: {
            getProductDeliveryTime: true,
            ajax: true,
            id_product: $("#product_page_product_id").val(),
            id_combination: idCombination
        },
        success: function (data) {
            $('.delivery-time-text div').spinner('end');
            $('#delivery-time-box .delivery-time-text div').html(data);
        }
    });
}





